var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuschasegoldCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40145",
    "data-name": "Group 40145",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.044,
    height: 29.096,
    viewBox: "0 0 28.044 29.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26585",
    "data-name": "Path 26585",
    d: "M46.513,32.58a8.4,8.4,0,1,0-8.4,8.4A8.408,8.408,0,0,0,46.513,32.58Zm-8.4,7.144A7.144,7.144,0,1,1,45.26,32.58,7.152,7.152,0,0,1,38.115,39.724Z",
    transform: "translate(-24.172 -20.424)",
    fill: "#c38f51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26586",
    "data-name": "Path 26586",
    d: "M43.276,31.843,41,28.364l-2.21,3.551L34.777,33l2.694,3.2-.2,4.153,3.874-1.574,3.887,1.476-.3-4.171,2.605-3.241Zm.362,6.547-2.511-.954-2.511,1.019.131-2.683L37,33.7l2.592-.7,1.433-2.3L42.5,32.941l2.631.651-1.683,2.094Z",
    transform: "translate(-27.117 -22.858)",
    fill: "#c38f51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26587",
    "data-name": "Path 26587",
    d: "M39.975,33.539l1.517-1.1-.15-2.869,1.325-2.472-1.38-2.52.122-2.8L39.073,20.1l-1.106-2.578-2.83-.492L33.022,15.19l-2.763.784-2.7-.742L25.4,17.138l-2.759.5-1.11,2.65-2.267,1.652.15,2.869-1.326,2.472,1.38,2.52-.122,2.8,1.5,1.072-4.4,4.4L20.93,39.8l1.724,4.482,5.1-5.1L30.5,38.4l2.655.729,5.128,5.127,1.724-4.482,4.482-1.724ZM21.9,38.833,18.7,37.6l3.09-3.091,1.005,2.343,2.83.492L26.8,38.368l-3.666,3.666ZM30.5,37.1l-2.446.695-1.867-1.626-2.505-.435L22.7,33.461l-2.069-1.479.108-2.473L19.52,27.278,20.69,25.1l-.133-2.54,2-1.458.982-2.346,2.435-.445,1.9-1.687,2.387.655,2.446-.695,1.866,1.626,2.506.435.976,2.275L40.127,22.4l-.108,2.473L41.241,27.1l-1.17,2.181.133,2.54-2,1.458-.983,2.346-2.435.445-1.9,1.688Zm8.543,1.706-1.232,3.2-3.681-3.68,1.228-1.09,2.759-.5.97-2.314,3.156,3.156Z",
    transform: "translate(-16.448 -15.19)",
    fill: "#c38f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuschasegoldCardIcon);
export default __webpack_public_path__ + "static/media/puschase&goldCardIcon.dca9cdf7f0e9d1a5fac8ef89e94b0c11.svg";
export { ForwardRef as ReactComponent };